import axios from 'axios'
import router from '../router'
import ToastService from '@/services/toasterService'
import _ from 'lodash'
import Cookie from 'js-cookie'
import store from '../store'
// import store from './store/'

const CancelToken = axios.CancelToken
const BASE_URL = process.env.VUE_APP_API_BASE_URL || '/rest'
export const cancelTokens = {}
const manuallyCanceledMessage = 'cancelled by user'
const noPlanOrProductMessage = 'no-plan-or-product'
const noProjectAssociationMessage = 'no-project-association'
const noPermissionMessage = 'no-permission'
const noClientMessage = 'no-client'
const invalidBillingStatusMessage = 'invalid-billing-status'

axios.defaults.baseURL = BASE_URL
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

const fileDownloadPaths = [
  '/rest/importer/download',
  '/rest/link/download-attachment'
]

const v2ApiPaths = [
  /^\/?keyword-census\/aggregates(?:\/[0-9a-f]{32})?$/,
  /^\/?web_property\/remove(?:\/[0-9a-f]{32})?$/,
  /^\/?rank-report(?:\/[0-9a-f]{32})?$/,
  /^\/?content-briefs\/get-optimized-kiss-score(?:\/[0-9a-f]{32})?$/,
  /^\/?content-briefs\/get-keywords-snapshot(?:\/[0-9a-f]{32})?$/,
  /^\/?content-briefs\/compare-snapshots(?:\/[0-9a-f]{32})?$/,
  /^\/?content-briefs\/get-content-brief(?:\/[0-9a-f]{32})?$/,
  /^\/?keyword-ranking-report(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/progress(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/compare-competition-snapshots(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/section(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/keyword(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/keyword_movement(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/compare-url-snapshots(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/keyword-movement-history(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/keyword_compare(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/competition(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/url(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/keyword_movement_progress(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/keyword_movement_snapshot(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/list-snapshot-dates(?:\/[0-9a-f]{32})?$/,
  /^\/?reports\/rankzone-report\/status(?:\/[0-9a-f]{32})?$/
]
/**
 * extra axios options:
 * cancelErrorMessage - flag to do not show error in interceptor
 * successMessage - success message to show it in interceptor
 * raiseError - flag to raise error for further handling
 * example:
 * httpService.get(`/your_endpoint`, { params: params }, { successMessage: 'Successfully Shared!', raiseError: true })
 */
axios.interceptors.response.use(
  response => {
    removeCancelToken(response.config.url + (![undefined, null].includes(response.config.tokenNameModificator) ? `-${response.config.tokenNameModificator}` : ''))
    const errors = _.get(response, 'data.data.errors', [])
    if (errors.length) {
      if (!response.config.cancelErrorMessage) {
        showErrorToast(errors)
      }
      if (response.config.raiseError) {
        return Promise.reject(errors)
      }
      return // todo tbd should we return something while error or not
    } else if (response.config.successMessage && response?.status !== 204) {
      showToast(ToastService.SUCCESS_TYPE, response.config.successMessage)
    } else if (response.config.infoMessage) {
      showToast(ToastService.INFO_TYPE, response.config.infoMessage)
    }
    /*
      on file downloads, we need access to the full response object
      in order to get the filename from the headers
    */
    if (fileDownloadPaths.includes(response.config.url)) {
      return response
    } else if (response.config.returnWithUrl) {
      return { data: response.data, url: response.request.responseURL }
    }
    return response.data
  },
  error => {
    if (error.response?.status === 403) {
      store.state.agency.shouldSelectPaymentPlan = false
      if (error.response.data.data.errors.includes(noPlanOrProductMessage)) {
        showToast(ToastService.ERROR_TYPE, 'Missing plan or product')
        store.state.agency.shouldSelectPaymentPlan = true
        console.log('store.state.agency.shouldSelectPaymentPlan', store.state.agency.shouldSelectPaymentPlan)
      } else if (error.response.data.data.errors.includes(noProjectAssociationMessage)) {
        showToast(ToastService.ERROR_TYPE, 'Missing project')
        store.state.agency.shouldCreateProject = true
      } else if (error.response.data.data.errors.includes(noPermissionMessage) && !error?.config?.headers['resource-page']?.startsWith('/user/')) {
        showToast(ToastService.ERROR_TYPE, 'You are not authorized to view this resource')
        // router.go(store.state.previousPage)
      } else if (error.response.data.data.errors.includes(noClientMessage)) {
        showToast(ToastService.ERROR_TYPE, 'Missing project')
        router.go(store.state.previousPage)
      } else if (error.response.data.data.errors.includes(invalidBillingStatusMessage)) {
        showToast(ToastService.ERROR_TYPE, 'Invalid billing status')
        // go to billing page
        router.push('/system/billing')
      }
      return
    }
    if (error.message === manuallyCanceledMessage) {
      return
    }
    if (error.config && !error.config.cancelErrorMessage) {
      showErrorToast(error)
    }
    if (error.config && error.config.raiseError) {
      return Promise.reject(error)
    }
  })

axios.interceptors.request.use(
  config => {
    // config.headers.resource_page = router.currentRoute.path
    config.headers['resource-page'] = router.currentRoute.path
    const source = CancelToken.source()
    const method = config.method
    // add cancelToken to cancel request by repeated call
    cancelTokens[config.baseURL + config.url + (![undefined, null].includes(config.tokenNameModificator) ? `-${config.tokenNameModificator}` : '')] = source

    /*
      config.isFormData is an optional config property - when set to true it bypasses
      the statement below - this is necessary for file uploads
    */
    if (['post', 'patch', 'delete'].includes(method) && !config.isFormData) {
      config.data = jsonToUrlEncoded(config.data)
    }
    if (window.getUnhashedCurrentClientId) {
      const clientId = window.getUnhashedCurrentClientId()
      Cookie.remove('fk_client_id')
      Cookie.set('fk_client_id', clientId)
    }
    if (process.env.VUE_APP_IS_V2_API === 'true' &&
      v2ApiPaths.some(path => config.url.match(path))
    ) {
      config.baseURL += '/v2'
    }
    return {
      ...config,
      cancelToken: source.token
    }
  }
)

const showToast = _.throttle((type, message) => ToastService.showToast(type, message), 500, { leading: true, trailing: false })

function showErrorToast(error) {
  if (error.response?.status === 500) {
    // ToastService.showToast(ToastService.ERROR_TYPE, 'Internal server error')
    return
  }
  let message = 'Network error'
  if (typeof error !== 'undefined') {
    if (error instanceof Array) {
      // todo consider to show all errors in array
      message = error[0]
    } else if (error.message) {
      message = error.message
    }
  }
  showToast(ToastService.ERROR_TYPE, message)
}

/**
 * recursive function for encode json data
 */
function jsonToUrlEncoded(element, key, list) {
  list = list || []
  if (typeof (element) === 'object') {
    for (const idx in element) {
      jsonToUrlEncoded(element[idx], key ? key + '[' + idx + ']' : idx, list)
    }
  } else {
    list.push(key + '=' + encodeURIComponent(element))
  }
  return list.join('&')
}

function removeCancelToken(url) {
  cancelTokens[url] && (delete cancelTokens[url])
}

/**
 * function breaks pending request based on url
 * @param url - canceled url
 */
async function breakRequest(url) {
  await cancelTokens[url].cancel(manuallyCanceledMessage)
  removeCancelToken(url)
}

/**
 * function wrappes all pending requests into Promise to break them
 */
function breakAll() {
  const requests = []
  Object.keys(cancelTokens).forEach(async key => {
    requests.push(breakRequest(key))
  })
  return Promise.all(requests)
}

function breakRequestByURL(url) {
  url = BASE_URL + url
  const cancelToken = cancelTokens[url]
  if (cancelToken) {
    cancelToken.cancel(manuallyCanceledMessage)
    removeCancelToken(url)
  }
}

export default {
  get: axios.get,
  patch: axios.patch,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  breakAllRequests: breakAll,
  breakRequestByURL,
  axios
}
